import { createStaticEventMapWithLatLng } from '@/commonFunctions/utils'
import { Email, Navigation, Phone } from '@/components/icons'
import { ROUTE_CLUBS } from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useMediaQuery, useWindowSize } from 'usehooks-ts'
import { eventSelector } from '../selectors'

export const Detail = () => {
  const { t } = useTranslation()

  const { event } = useAppSelector(eventSelector)
  const { width } = useWindowSize()

  const isMobile = useMediaQuery('(max-width: 767px)')

  const [aboutHtml, setAboutHtml] = useState('')

  const redirectToMap = (latitude?: number, longitude?: number) => {
    if (latitude && longitude) {
      const url = `https://www.google.com/maps?q=${latitude},${longitude}`
      window.open(url, '_blank')
    }
  }

  useEffect(() => {
    if (event) setAboutHtml(`${event?.longDescription?.content ? event?.longDescription?.content : ''}`)
  }, [event])

  return (
    <div className="flex flex-col gap-y-3">
      <h2 className="text-xl text-white font-semibold">{t('common.details')}</h2>
      <div className="bg-white w-full rounded-2xl md:px-4 md:pt-6 pb-9 flex flex-col gap-y-4">
        <div className="flex-col md:flex md:flex-row md:pb-6">
          {event && (
            <img
              src={createStaticEventMapWithLatLng({
                w: isMobile ? width : 240,
                h: isMobile ? 176 : 240,
                lat: event?.address?.latitude,
                lng: event?.address?.longitude,
              })}
              alt="event map"
            />
          )}

          <div className="flex flex-col gap-y-1 justify-center p-4 md:p-0 md:pl-4">
            <Link
              to={`${ROUTE_CLUBS}/${event?.clubId}`}
              className="text-navy-900 text-opacity-80 font-semibold text-base max-w-[192px] md:w-full"
            >
              {event?.clubName}
            </Link>
            <span className="text-navy-900 text-opacity-50 text-sm max-w-[192px] md:w-full">
              {event?.address?.formattedAddress}
            </span>
            <button
              className="flex bg-primary-500 items-center py-2 px-4 rounded-full gap-x-1 text-white text-sm font-semibold w-28 mt-2"
              onClick={() => redirectToMap(event?.address?.latitude, event?.address?.longitude)}
            >
              <Navigation className="text-white" />
              {t('common.navigate')}
            </button>
          </div>
        </div>

        <div className="flex flex-col gap-y-4 px-4 md:px-0">
          <h3 className="text-navy-900 text-xl font-semibold">{t('club.clubContact')}</h3>
          <div className="flex flex-col gap-y-2">
            <div className="flex gap-x-1 items-center">
              <Email className="text-navy-900" />
              <span className="text-sm text-navy-900">{event?.contactDetails[0]?.email}</span>
            </div>
            <div className="flex gap-x-1 items-center">
              <Phone className="text-navy-900" />
              <span className="text-sm text-navy-900">{event?.contactDetails[0]?.phone}</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-y-4 px-4 md:px-0">
          <h3 className="text-navy-900 text-xl font-semibold">{t('event.aboutTheEvent')}</h3>
          <div className="text-navy-900 text-opacity-60 text-sm" dangerouslySetInnerHTML={{ __html: aboutHtml }} />
        </div>
      </div>
    </div>
  )
}
